<template>
  <div>
    <p>{{contact.name}}</p>

    <template v-if="contact.organization || contact.title">
      <p>
        <template v-if="contact.title">
          {{contact.title}}<template v-if="contact.organization"> at </template>
        </template>
        {{contact.organization}}
      </p>
    </template>

    <template v-if="contact.prospectType === 'account' && contact.industry">
      <p>{{contact.industry}}</p>
    </template>
  </div>
</template>

<script>
export default {
  props: [
    'contact'
  ]
}
</script>



// WEBPACK FOOTER //
// ContactDetails.vue?10da6db4